export enum EResponseStatus {
	PENDING = 'pending',
	OK = 'fulfilled',
	ERROR = 'error',
}
